<template>
<section>
    <div class="wrap">

        <div class="my_reservation_detail">

            <span :class="['my_reservation_state', { 'ok' : (bookingItem.status == BOOKING_STATUS.CONFIRMED.id) }]">
                {{ (bookingItem.status) ? bookingTitle(bookingItem.status) : '' }}
            </span>

            <p>{{ (bookingItem.status) ? bookingAdminMemo(bookingItem.status, bookingItem.adminMemo) : '' }}</p>

            <div class="showroom_info">
                <!-- <figure><img :src="`${(bookingItem.sc) ? booking.sc.att.url : ''}`"></figure> -->
                <figure>
                    <img v-if="bookingItem.scAtt" :src="bookingItem.scAtt.url">
                    <img v-else :src="`${$store.state.dir}images/user_icon.png`">
                </figure>
                <dl>
                    <dt>{{ (bookingItem.sc) ? bookingItem.sc.name : '' }} 컨설턴트</dt>
                    <dd>{{ (bookingItem.shop) ? bookingItem.shop.name : '' }} ({{ (bookingItem.dealer) ? bookingItem.dealer.name : '' }})</dd>
                </dl>
            </div>
        </div>
        <div class="my_reservation_detail" style="margin-top:10px; animation: opacity2 0.8s;">
            <div class="my_reservation_info">
                <img data-v-58bfe502="" src="https://prebook-local.s3.ap-northeast-2.amazonaws.com/att/0103/1/2021_10_25_1635128064366_sample.png">
                <dl>
                    <dt style="line-height:1.4;">
                        {{ (bookingItem.model) ? bookingItem.model.name : '' }} {{ (bookingItem.trim) ? bookingItem.trim.name : '' }}
                        
                    </dt>
                    <template v-if="bookingItem.status == BOOKING_STATUS.CHANGE.id">
                        <dd>
                            <span class="change">변경 전 일정</span>
                            <span>{{bookingDate(bookingItem.bookingDt)}}</span>
                            <span>{{bookingTime(bookingItem.bookingDt)}}</span></dd>
                        <dd>
                            <span class="change">변경 후 일정</span>
                            <span>{{bookingDate(bookingItem.bookingChangeDt)}}</span>
                            <span>{{bookingTime(bookingItem.bookingChangeDt)}}</span>
                        </dd>
                    </template>

                    <dd v-else>
                        <span>{{bookingDate(bookingItem.bookingDt)}}</span>
                        <span>{{bookingTime(bookingItem.bookingDt)}}</span>
                    </dd>  
                </dl>
                
            </div> 
        </div>
        <div class="my_reservation_btn_box" v-if="bookingItem.status == BOOKING_STATUS.WAIT.id">
            <button @click="bookingChange()">예약변경</button>
            <button @click="bookingCancel()">예약취소</button>
        </div>

        <div class="my_reservation_btn_box mb10" v-if="bookingItem.status == BOOKING_STATUS.CHANGE.id">
            <button @click="bookingChangeOk()">변경승인</button>
            <button @click="bookingChange()">다른일정으로 예약</button>
        </div>

        <div class="my_reservation_cancel" v-if="[BOOKING_STATUS.CHANGE.id,BOOKING_STATUS.CONFIRMED.id].includes(bookingItem.status)">
            <a @click="bookingCancel()">예약취소<img :src="`${$store.state.dir}images/right_arrow.png`"></a>
        </div>
        
        <div class="my_reservation_detail_map">
            <p class="address">
                위치
                <span>{{ (bookingItem.shop) ? bookingItem.shop.addr : '' }}</span>
            </p>
            <div class="map">
                <div class="mapMask"></div>
                <KakaoMap style="width:100%; height:200px;" v-if="$store.state.common.onload"
                    ref="kakaoMap"
                    :lat="(bookingItem.shop) ? bookingItem.shop.lat : 0"
                    :har="(bookingItem.shop) ? bookingItem.shop.har : 0"
                ></KakaoMap>
            </div>

            <p class="title">예약정보</p>
            <div class="table_box">
                <table>
                    <tbody>
                        <tr>
                            <th>이름</th>
                            <td>{{ (bookingItem.user) ? bookingItem.user.name : '' }}</td>
                        </tr>
                        <tr>
                            <th>연락처</th>
                            <td>{{ (bookingItem.user) ? bookingItem.user.phone : '' }}</td>
                        </tr>
                        <tr>
                            <th>고객 차량</th>
                            <td>{{bookingItem.userVehicle}}</td>
                        </tr>
                        <tr>
                            <th>고객 차량번호</th>
                            <td>{{bookingItem.userVehicleNum}}</td>
                        </tr>
                        <tr>
                            <th>예약 목적</th>
                            <td>{{bookingType(bookingItem.type)}}</td>
                        </tr>
                        <tr>
                            <th>요청사항</th>
                            <td>
                                <tempalte v-for="(bookingChoiceItem,index) in bookingChoiceView" :key="index">
                                    {{bookingChoiceItem}} <br>
                                </tempalte>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <p class="title">기타 요청사항</p>
            <p>{{bookingItem.userMemo}}</p>
        </div>
    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { BookingFormatMixin } from '../../mixins/BookingFormatMixin';
import KakaoMap from '../../components/map/KakaoMap.vue';

export default {
    name:'BookingItem',
    mixins:[BookingFormatMixin],
    components: {
        KakaoMap,
    },
    data() {
        return {}
    },
    async created() {
        this.$store.state.headerTitle = '예약내역 상세';
        await this.$store.dispatch('GET_BOOKING', this.bookingId);
        this.$store.commit('SHOW_ONLOAD');
    },
    computed: {
        ...mapState({
            auth: state => state.auth.item,
            bookingItem: state => state.booking.item,
            bookingWrite: state=>state.booking.itemWrite,
            BOOKING_STATUS: state => state.codeDictionary.items.BOOKING_STATUS,
        }),
        bookingId() {
            return this.$route.params.bookingId;
        },
        bookingChoiceView() {
            let bookingChoice = (this.bookingItem.choice) ? this.bookingItem.choice.split(',') : [];
            return bookingChoice.map(e => this.bookingChoice(e.choice)).filter(Boolean);
        },
    },
    methods: {
        bookingChange(){
        
            this.bookingWrite.type = this.bookingItem.type;

            this.bookingWrite.brandId = this.bookingItem.brand.id;
            this.bookingWrite.brandName = this.bookingItem.brand.name;
            this.bookingWrite.brandUrl = this.bookingItem.brand.attUrl;

            this.bookingWrite.modelId = this.bookingItem.model.id;
            this.bookingWrite.modelName = this.bookingItem.model.name;
            this.bookingWrite.modelUrl = this.bookingItem.modelAtt.url;

            this.bookingWrite.trimId = this.bookingItem.trim.id;
            this.bookingWrite.trimName = this.bookingItem.trim.name;

            this.bookingWrite.scName = this.bookingItem.sc.name;
            this.bookingWrite.scUrl = this.bookingItem.scAtt.url;
            this.bookingWrite.scShopName = this.bookingItem.shop.name;
            this.bookingWrite.scDealerName = this.bookingItem.dealer.name;

            this.$router.push(`/booking/inputBasic/${this.bookingItem.id}`)
        },

        bookingChangeOk(){
            this.$store.commit('OPEN_MODAL', {
                content:'예약 변경을 승인하시겠습니까?',
                btnOne:'예',
                btnOneSubmit: this.bookingChangeOkSubmit,
                btnTwo:'아니오',
            });
        },

        bookingChangeOkSubmit(){
            this.$store.dispatch('CHANGE_BOOKING', this.bookingId)
            .then(()=>{
                this.$store.commit('OPEN_MODAL', {
                    content:'예약 변경이 완료되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => { this.$router.push('/myBookingList') }
                })
            })
            .catch((e)=>{
                this.apiCatch(e);
            });
        },

        bookingCancel(){
            this.$store.commit('OPEN_MODAL', {
                content:'예약을 취소하시겠습니까?',
                btnOne:'예',
                btnOneSubmit: this.bookingCancelSubmit,
                btnTwo:'아니오',
            });
        },

        bookingCancelSubmit(){
            this.$store.dispatch('CANCEL_BOOKING', this.bookingId)
            .then(()=>{
                this.$store.commit('OPEN_MODAL', {
                    content:'예약이 취소되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => { this.$router.push('/main') }
                })
            })
            .catch((e)=>{
                this.apiCatch(e);
            });
        }
    },
}
</script>

<style scoped>

</style>